export const LOCALE_COOKIE_KEY = 'community_locale'

export const DEFAULT_LOCALE = 'en'

export const ACCEPT_LANGUAGE_MAP = {
  de: 'de',
  en: 'en',
  es: 'es',
  fr: 'fr',
  it: 'it',
  jp: 'ja',
  kr: 'ko',
  pl: 'pl',
  pt: 'pt',
  ru: 'ru',
  tw: 'zh-TW',
}

export const SUPPORTED_LOCALES = [
  'ar',
  'cz',
  'de',
  'en',
  'es',
  'fr',
  'id',
  'it',
  'jp',
  'kr',
  'pl',
  'pt',
  'ru',
  'sk',
  'ta',
  'tw',
  'yn',
  'zh',
]

export function isSupportedLocale(locale) {
  return SUPPORTED_LOCALES.includes(String(locale || '').trim())
}

export function normalizeLocale(locale) {
  const normalized = String(locale || '').trim()
  return isSupportedLocale(normalized) ? normalized : DEFAULT_LOCALE
}

export function getAcceptLanguage(locale) {
  return ACCEPT_LANGUAGE_MAP[normalizeLocale(locale)] || DEFAULT_LOCALE
}
